var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.449 0H21.551C9.64872 0 0 9.64872 0 21.551V110.449C0 122.351 9.64872 132 21.551 132H110.449C122.351 132 132 122.351 132 110.449V21.551C132 9.64872 122.351 0 110.449 0Z",
    fill: "#452222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.449 5.3877H21.551C12.6242 5.3877 5.3877 12.6242 5.3877 21.551V110.449C5.3877 119.376 12.6242 126.612 21.551 126.612H110.449C119.376 126.612 126.612 119.376 126.612 110.449V21.551C126.612 12.6242 119.376 5.3877 110.449 5.3877Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3878 67.3467H39V126.612H44.3878V67.3467Z",
    fill: "#1B1625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.39 67.3467H88V126.612H93.39V67.3467Z",
    fill: "#1B1625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 0H58.3265V80.8163C58.3265 82.3042 57.1205 83.5102 55.6327 83.5102H28.6939C27.206 83.5102 26 82.3042 26 80.8163V0Z",
    fill: "#1B1625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 0H106.33V80.8163C106.33 82.3042 105.014 83.5102 103.391 83.5102H76.9391C75.3158 83.5102 74 82.3042 74 80.8163V0Z",
    fill: "#1B1625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21.551C0 9.64871 9.64871 0 21.551 0H110.449C122.351 0 132 9.64871 132 21.551H0Z",
    fill: "#943939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogoRed);
export default __webpack_public_path__ + "static/media/dark-logo-red.cd31508e3cc262eec02f40a2c64ce3eb.svg";
export { ForwardRef as ReactComponent };